// Format phone for WhatsApp deep link (country code from config, default 595 Paraguay)
export function whatsappPhone(raw, codigoPais = "595") {
  if (!raw) return null;
  let digits = String(raw).replace(/\D/g, "");
  if (!digits) return null;
  if (digits.startsWith("0")) digits = digits.slice(1);
  const cc = String(codigoPais || "595");
  if (!digits.startsWith(cc)) digits = cc + digits;
  return digits;
}

const DIAS = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
const MESES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

function formatFecha(fecha) {
  if (!fecha) return "";
  const [y, m, d] = fecha.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return `${DIAS[dt.getDay()]} ${d} de ${MESES[m - 1]}`;
}

const TIPO_LABEL = {
  origen: "Test ORIGEN (evaluación inicial)",
  sesion: "sesión",
  otro: "consulta",
};

// Original message: appointment confirmation (kept for backward compat with Agenda/Dashboard)
export function buildWhatsAppLink(turno, config = {}) {
  const phone = whatsappPhone(turno.paciente_telefono, config.codigo_pais_whatsapp);
  const origin = window.location.origin;
  const confirmUrl = `${origin}/confirmar/${turno.confirmation_token}`;
  const modalidad = TIPO_LABEL[turno.tipo] || "consulta";
  const nombre = (turno.paciente_nombre || "").split(" ")[0] || "";
  const titulo = config.profesional_titulo || "Lic.";
  const profNombre = config.profesional_nombre || "";
  const msg =
    `Hola ${nombre}, te confirmo tu ${modalidad} en el consultorio de ${titulo} ${profNombre}:\n\n` +
    `📅 ${formatFecha(turno.fecha)}\n` +
    `🕘 ${turno.hora} hs\n` +
    `👤 ${turno.profesional_nombre}\n\n` +
    `Podés confirmar tu asistencia acá:\n${confirmUrl}\n\n` +
    `¡Te esperamos!`;
  const text = encodeURIComponent(msg);
  return phone ? `https://wa.me/${phone}?text=${text}` : `https://wa.me/?text=${text}`;
}

/**
 * Build a WhatsApp link for a specific quick action on a patient.
 * action ∈ {chat, recordatorio, ubicacion, indicacion, documento, seguimiento}
 */
export function buildPacienteWhatsApp(paciente, action, config = {}, extras = {}) {
  const phone = whatsappPhone(paciente.telefono, config.codigo_pais_whatsapp);
  const nombre = (paciente.nombre || "").split(" ")[0] || "";
  const titulo = config.profesional_titulo || "Lic.";
  const profNombre = config.profesional_nombre || "";
  const consultorio = config.consultorio_nombre || "el consultorio";
  const direccion = config.consultorio_direccion || "";
  const gmaps = config.consultorio_gmaps_url || (direccion ? `https://maps.google.com/?q=${encodeURIComponent(direccion)}` : "");

  let msg = "";
  switch (action) {
    case "recordatorio":
      msg = `Hola ${nombre}, te recuerdo tu próxima consulta en ${consultorio}. Cualquier duda escribinos por acá. ¡Te esperamos!`;
      if (extras.turno) {
        msg = `Hola ${nombre}, te recordamos tu próxima consulta en ${consultorio}:\n\n` +
          `📅 ${formatFecha(extras.turno.fecha)}\n` +
          `🕘 ${extras.turno.hora} hs\n\n` +
          `¿Podés confirmarnos que vas a venir? ¡Gracias!`;
      }
      break;
    case "ubicacion":
      msg = `Hola ${nombre}, te comparto la ubicación del consultorio:\n\n${direccion ? `📍 ${direccion}\n` : ""}${gmaps ? `${gmaps}\n\n` : ""}¡Nos vemos!`;
      break;
    case "indicacion":
      msg = `Hola ${nombre}, te dejo unas indicaciones antes de tu próxima consulta:\n\n${extras.texto || "• Traé un DNI/CI\n• Llegá 10 min antes\n\nCualquier duda, escribinos."}`;
      break;
    case "documento":
      msg = `Hola ${nombre}, ¿podrías enviarnos ${extras.texto || "el documento que te pedimos"} por acá cuando puedas? ¡Gracias!`;
      break;
    case "seguimiento":
      msg = `Hola ${nombre}, ¿cómo estás? Queríamos saber cómo venís y si querés retomar las consultas con ${titulo} ${profNombre}. ¡Un abrazo!`;
      break;
    case "chat":
    default:
      msg = extras.texto || `Hola ${nombre}, te escribo del consultorio de ${titulo} ${profNombre}.`;
  }

  const text = encodeURIComponent(msg);
  return phone ? `https://wa.me/${phone}?text=${text}` : `https://wa.me/?text=${text}`;
}
